// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"4b8431df467242e1ac44","678":"a52ed11a666276a83528","883":"58f0275bfdeb72aa8f4f"}[chunkId] + ".js";
};